import store from 'redux/store';
import { showDialog } from 'dialogs';
import EditConfigItem from '../editConfigItem';

export type ShowEditConfigItemArgs = { readonly mode: 'create' } | { readonly mode: 'edit'; readonly id: number };

// EditConfigItem addresses a config by its index in the store list; resolve the
// config id to that index at open time.
const findConfigIndex = (id: number): number | null => {
  const index = store.getState().config.items.findIndex((c: any) => c.config_id === id);
  return index >= 0 ? index : null;
};

/** Open the config-item create / edit modal via showDialog. */
export const showEditConfigItem = (args: ShowEditConfigItemArgs): void => {
  const isNew = args.mode === 'create';
  const configIndex = isNew ? null : findConfigIndex(args.id);
  showDialog((close) => <EditConfigItem configIndex={configIndex} isNew={isNew} handleClose={close} />);
};
